import { LegalPartnersForm } from "./LegalPartnersForm";

export { LegalPartnersForm };
